const $ = require('jquery')
const Vue = require('vue')
const R = require('ramda')
const Promise = require('bluebird')

const Dropzone = require('dropzone')

const SCI = require('sci')

const { backendUrl } = require('sci/utils')
const { globalChaos, guid } = require('sci/helpers')

const pica = require('pica/dist/pica')()

const createFitCanvas = (originalWidth, originalHeight, maxWidth, maxHeight) => {
    let targetWidth = originalWidth
    let targetHeight = originalHeight

    if (targetWidth > maxWidth) {
        targetWidth = maxWidth
        targetHeight = Math.ceil((maxWidth / originalWidth) * originalHeight)
    }

    if (targetHeight > maxHeight) {
        targetHeight = maxHeight
        targetWidth = Math.ceil((maxHeight / originalHeight) * originalWidth)
    }

    const canvas = document.createElement('canvas')

    canvas.width = targetWidth
    canvas.height = targetHeight

    return canvas
}

Vue.component('new-dropzone', require('components/std/NewDropzone.vue'))

Vue.directive('dropzone', {
    twoWay: true,
    priority: 1000,

    params: ['url', 'on-new'],

    paramWatchers: {
        url () {
            this.build()
        }
    },

    bind () {
        this.build()
    },
    update (value) {
        this.build()
    },
    unbind: function () {
    },

    build () {
        Vue.nextTick(() => {
            const self = this
            const token = SCI.get('token')

            const id = guid()

            self.el.id = id

            if (self.el.dropzone) {
                self.el.dropzone.destroy()
            }

            this.dz = new Dropzone(self.el, {
                url: backendUrl(self.params.url),
                headers: {
                    'X-Authorization': `Bearer ${token}`
                },
                clickable: self.el.querySelector('.clickable-area'),
                autoQueue: false,
                createImageThumbnails: false
            })

            this.dz.on('addedfile', (originalFile) => {
                if (originalFile.type.indexOf('image') !== 0) {
                    self.dz.removeFile(originalFile)
                    return
                }

                const originalUrl = window.URL.createObjectURL(originalFile)

                const originalImage = new window.Image()

                originalImage.src = originalUrl

                originalImage.addEventListener('load', function () {
                    const { width, height } = originalImage

                    const originalDestImage = createFitCanvas(width, height, 1920, 1920)
                    const thumbDestImage = createFitCanvas(width, height, 400, 400)

                    Promise.props({
                        original: pica.resize(originalImage, originalDestImage, {})
                    }).then(({ original }) => {
                        return Promise.props({
                            original,
                            thumb: pica.resize(originalImage, thumbDestImage, {})
                        })
                    }).then(({ original, thumb }) => {
                        return Promise.props({
                            original: pica.toBlob(original, 'image/jpeg', 100),
                            thumb: pica.toBlob(thumb, 'image/jpeg', 100)
                        })
                    }).then(({ original, thumb }) => {
                        original.lastModifiedDate = new Date()

                        Object.assign(original, R.pick([
                            'status',
                            'previewElement',
                            'previewTemplate',
                            'accepted',
                            'upload',
                            'name'
                        ], originalFile))

                        original.upload.total = original.size

                        const originalFileIndex = self.dz.files.indexOf(originalFile)
                        self.dz.files[originalFileIndex] = original

                        self.dz.enqueueFile(original)
                    })
                })
            })

            this.dz.on('error', (file) => {
                this.dz.removeFile(file)
                this.dz.processQueue()
            })

            this.dz.on('complete', (file) => {
                const body = JSON.parse(file.xhr.response)
                globalChaos(body)
                    .then((data) => {
                        if (self.params.onNew) {
                            self.params.onNew(data)
                        }
                    })
                    .finally(() => {
                        this.dz.removeFile(file)
                    })
            })
        })
    }
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/dropzone.js